import { CRUDAction, FeatureKey } from 'common/constants/permission'
import { useFeatureEnabled } from 'core/feature-config/api/queries'
import { useGetCRUDByFeature } from 'modules/user/api/selector'

// Org-wide setting: whether starting a cycle deducts credit at all.
// Independent of the current user's own permission to view/manage the wallet.
export const useCreditWalletFeatureEnabled = () => {
  const { data: featureEnabled } = useFeatureEnabled('CREDIT_WALLET')
  return featureEnabled === true
}

export const useCreditWalletAccess = () => {
  const featureEnabled = useCreditWalletFeatureEnabled()
  const creditCRUD = useGetCRUDByFeature(FeatureKey.Credit)

  const canView = featureEnabled && creditCRUD?.[CRUDAction.Read] === 1
  const canTopUp = canView && creditCRUD?.[CRUDAction.Create] === 1

  return { canView, canTopUp }
}
